// Fetch wrapper that automatically uses the correct API base URL
const API_BASE_URL = (() => {
  const explicit = process.env.REACT_APP_API_URL;
  if (explicit) {
    return explicit.replace(/\/api$/, ''); // Remove trailing /api if present
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname?.toLowerCase();
    const isLocal =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === '::1';
    if (isLocal) return 'http://localhost:5000';
  }

  return 'const API_BASE_URL = "https://pathmarkr-alb-1917965496.us-east-1.elb.amazonaws.com";';
})();

// Override global fetch to handle relative /api/ URLs
const originalFetch = window.fetch;

window.fetch = function(url, options) {
  // If URL starts with /api/, prepend the API base URL
  if (typeof url === 'string' && url.startsWith('/api/')) {
    url = `${API_BASE_URL}${url}`;
  }

  // changed by me — bypass ngrok browser interstitial warning page for local dev
  // Only for requests to our backend — adding it to third-party URLs forces CORS preflights they reject
  if (API_BASE_URL.includes('ngrok') && typeof url === 'string' && url.startsWith(API_BASE_URL)) {
    options = { ...(options || {}) };
    const headers = new Headers(options.headers || {});
    headers.set('ngrok-skip-browser-warning', 'true');
    options.headers = headers;
  }

  return originalFetch(url, options);
};

export default window.fetch;
